<div class="form-container" >
  <div class="cardLayout">
    <ion-row>
      <ion-col size="4">
        <!-- <div class="formLabelSemiBoldfs16 mb-5">{{ data.operation === 'Add' ? 'Add' : 'Edit' }} Reimbursement</div> -->
        <div class="formLabelSemiBoldfs16 mb-5" style="margin: 10px;">Employee Code Creation</div>
      </ion-col>

      <ion-col size="8" class="text-right">
        <img [mat-dialog-close] class="cp" src="././assets/icon/close_icon.png">
      </ion-col>
    </ion-row>

    <!-- authority-form.component.html -->
    <form [formGroup]="condidateForm" style="margin: 10px;">
      <ion-row>
      
       <ion-col size="6" class="mt-10" >
          <div class="formLabelRegularfs16 mb-5">Employee Code <span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="employeeCodeCreate" placeholder="type here"  readonly *ngIf="!isManual"/>
            <input matInput formControlName="employeeCode" placeholder="type here"  *ngIf="isManual"/>
            <mat-error *ngIf="hasError('firstName', 'required')">first name is required</mat-error>
          </mat-form-field>
        </ion-col>

        <ion-col size="6" class="mt-10">
          <div class="formLabelRegularfs16 mb-5">
            Email<span class="red-cl">&nbsp;*</span>
          </div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="mail" placeholder="Type here" />
            <mat-error *ngIf="hasError('mail', 'required')">Mail is required</mat-error>
            <mat-error *ngIf="hasError('mail', 'email')">Enter a valid email address</mat-error>
          </mat-form-field>
        </ion-col>
        
 
        <!-- Limit of Reimbursement -->

  
        
     
      </ion-row>

      <ion-row>
        <ion-col size="12" class="text-right mt-10">
          <button class="back_btn fs-14" (click)="cancelbutton()">Cancel</button>
          <button type="button" class="add_btn fs-14 ml-10" [style.background-color]="buttonColorName"[class.disabled]="condidateForm.invalid || isLoading"
          (click)="savecandidatedata()" >Send appoinment letter and convert
           
          </button>
        </ion-col>
      </ion-row>
    </form>

  </div>
</div>